module.exports = __webpack_public_path__ + "2b7565d22cc77fafc522b2d5bc82fb75.MP3";